import Urls from "../../api/endpoints";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Headings from "../../constants/headings";
import Constants from "../../constants/constants";
import React, { useEffect, useState, useCallback } from "react";
import { NotLogin, Loading } from "../../shared/index";
import { NidInquiryStatusType, LineStateStatusType } from "../../enums/index";
import {
  ErrorHandling,
  ToPersianNumber,
  DateToPersianNumber,
  getNidInquiryStatusClass,
  getNidInquiryStatusText,
  toEnglishNumber,
} from "../../functions";
import Actions from "./actions/actions";
import headings from "../../constants/headings";
import CustomValuesHook from "../../Hooks/customValuesHook";
import GSPTable from "../../shared/GSFTable";
import getNidInquiryStatusTextLine from "../../enums/getNidInquiryStatusTextLine";
import getNidInquiryStatusClassLine from "../../enums/getNidInquiryStatusClassLine";

function LinesList(props) {
  const navigate = useNavigate();
  const [data, setData] = useState({ data: [] });
  const [tableHeaders, setTableHeaders] = useState(
    Headings.ActivateLinesPageTableTitle
  );
  const [loading, setLoading] = useState(true);
  const [storedData, setStoredData] = useState(null);
  const [filter, setFilter] = useState(LineStateStatusType.Active());

  const [page, setPage] = useState(1);
  const [args, setArgs] = useState();

  const [value, setValue] = CustomValuesHook({
    filterType: "All",
    lineNumber: "",
  });

  function changeBackground(e) {
    e.currentTarget.className = "hovered";
  }
  function changeBackgroundBack(e) {
    e.currentTarget.className = "";
  }
  const goToUserPage = async (uri) => {
    navigate(`/${uri}`);
  };
  const [dropDownFilter, setDropDownFilter] = useState(
    Headings.LinesDropDownItemsText(filter)
  );

  useEffect(() => {
    getCrmLines();
  }, [props?.token]);

  const setNumberSerach = (lineNumber) => {
    let finalNumber = "98";
    if (lineNumber?.substring(0, 1) === "0")
      return (finalNumber =
        finalNumber + lineNumber?.substring(1, value?.lineNumber?.length));
    else return (finalNumber = finalNumber + lineNumber);
  };
  const getCrmLines = (args) => {
    let obj = {
      lineNumber:
        value?.lineNumber !== "" ? setNumberSerach(value?.lineNumber) : "",
      filterType: value?.filterType,
      filterAndSortConditions: args
        ? { ...args }
        : {
            pageSize: 100,
            pageNumber: 1,
          },
    };
    fetch(Urls.getCrmLinesList(), {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        data?.data.forEach((item, index) => {
          item.index = index;
        });
        let tmp = { ...data };
        tmp.data = data?.data;
        // tmp.pageNumber=data?.data?.pageNumber,
        // tmp.pageSize= data?.data?.pageSize,
        // tmp.totalCount=data?.data?.totalCount

        setData({ ...tmp });
      })
      .catch((error) => {
        ErrorHandling(error, "search error");
      });
  };

  const detailsComponent = ({ item }) => {
    return (
      <div
        style={{ color: "blue" }}
        onMouseOver={changeBackground}
        onMouseOut={changeBackgroundBack}
        onClick={() => {
          props.setSearch(true);
          props.setUserId(item?.customerId);
          if (
            item?.nidInquiryStatus === "ReadyForInquiry" ||
            item?.nidInquiryStatus === "InProgress"
          ) {
            goToUserPage("authentication");
          } else {
            goToUserPage("lines");
          }
        }}
      >
        نمایش جزییات
      </div>
    );
  };

  const rowComponent = ({ item }) => {
    return <div>{ToPersianNumber(item?.index + 1)}</div>;
  };

  const numberComponent = ({ item }) => {
    return (
      <div>
        {item?.isFree &&
          Constants.AuthHistoryArray.open +
            Constants.Free +
            Constants.AuthHistoryArray.close}
        {ToPersianNumber(item?.lineNumber)}
      </div>
    );
  };

  const nidInquiryStatusComponent = ({ item }) => {
    return (
      <div
        className={`td ${getNidInquiryStatusClassLine(item?.nidInquiryStatus)}`}
      >
        {getNidInquiryStatusTextLine(item?.nidInquiryStatus)}
      </div>
    );
  };

  const dateComponent = ({ item }) => {
    if (filter === LineStateStatusType.Active()) {
      return <div>{DateToPersianNumber(item?.persianActivationDate)}</div>;
    } else {
      return (
        <>
          <div>{DateToPersianNumber(item?.persianRejectionDate)}</div>
          <div>{item?.rejectionReason}</div>
        </>
      );
    }
  };

  const handleSearch = () => {
    getCrmLines();
  };

  const columns = [
    {
      title: "ردیف",
      property: "index",
      filterProperty: "null",
      hasSort: false,
      hasFilter: false,
      display: true,
      component: rowComponent,
    },
    {
      title: "شماره",
      property: "lineNumber",
      filterProperty: null,
      hasSort: true,
      hasFilter: false,
      display: true,
      component: numberComponent,
    },
    {
      title: "مشترک",
      property: "customerFullName",
      filterProperty: null,
      hasSort: true,
      hasFilter: true,
      display: true,
    },
    {
      title: "وضعیت احراز هویت",
      property: "nidInquiryStatus",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: nidInquiryStatusComponent,
    },
    {
      title: "تاریخ اختصاص خط",
      property: "HelpicalEmail",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: dateComponent,
    },
    {
      title: "جزییات",
      property: "",
      filterProperty: null,
      hasSort: false,
      display: true,
      component: detailsComponent,
    },
  ];

  // const handleGetData = (args) => {
  //   debugger;
  //   setPage(args.pageNumber);
  //   setPageSize(args.pageSize);
  //   setArgs({ ...args });
  //   getCrmLines();
  // };

  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : loading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-service-container">
            <div className="user-info">
              <h1>{Headings.ActivateLinesPageTitle}</h1>
              <div className="divider"></div>
              <Actions
                data={data}
                setData={setData}
                storedData={storedData}
                dropDownFilter={dropDownFilter}
                setFilter={setFilter}
                dropDownItems={headings.LinesDropDownItems}
                setValue={setValue}
                value={value}
                handleSearch={handleSearch}
              ></Actions>

              <Row>
                <Col>
                  <div>
                    {data?.data?.length > 0 ? (
                      <GSPTable
                        apiCall={getCrmLines}
                        columns={columns}
                        hasSorting={false}
                        dataList={data}
                        // options={options}
                        hasFiltering={false}
                        isSearchByExternalBtn={false}
                        loading={loading}
                        enableScrolling={false}
                        isStepScrolling={false}
                        hasPaging={true}
                        setDataListFromItem={setData}
                        pageSize={100}
                      />
                    ) : (
                      <p className="no-data">اطلاعات وجود ندارد</p>
                    )}
                  </div>

                  {/* <Table responsive className="roundedCorners">
                    <thead>
                      <tr>
                        {tableHeaders.map((h, index) => (
                          <th key={index}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data &&
                        data.map((d, index) => (
                          <tr
                            key={index}
                            onMouseOver={changeBackground}
                            onMouseOut={changeBackgroundBack}
                            onClick={() => {
                              props.setSearch(true);
                              props.setUserId(d.id);
                              if (
                                d.nidInquiryStatus ===
                                  NidInquiryStatusType.ReadyForInquiry() ||
                                d.nidInquiryStatus ===
                                  NidInquiryStatusType.InProgress()
                              ) {
                                goToUserPage("authentication");
                              } else {
                                goToUserPage("lines", d?.customerId);
                              }
                            }}
                          >
                            <td>{ToPersianNumber(index + 1)}</td>
                            <td className="ltr">
                              {" "}
                              {d.isFree &&
                                Constants.AuthHistoryArray.open +
                                  Constants.Free +
                                  Constants.AuthHistoryArray.close}
                              {ToPersianNumber(d.lineNumber)}
                            </td>
                            <td>{d.customerFullName}</td>
                            <td
                              className={`td ${getNidInquiryStatusClass(
                                d.nidInquiryStatus
                              )}`}
                            >
                              {getNidInquiryStatusText(d.nidInquiryStatus)}
                            </td>
                            {filter === LineStateStatusType.Active() ? (
                              <td>
                                {DateToPersianNumber(d.persianActivationDate)}
                              </td>
                            ) : (
                              <>
                                <td>
                                  {DateToPersianNumber(d.persianRejectionDate)}
                                </td>
                                <td>{d.rejectionReason}</td>
                              </>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </Table> */}
                </Col>
              </Row>
            </div>
          </div>
        </>
      )}
    </main>
  );
}
export default LinesList;
